/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PhonebookFileProgressStatus {
  NotStarted = 1,
  InProgress = 2,
  Finished = 3,
  HaveError = 4,
  InvalidFileData = 5,
  FileIsEmpty = 6,
  ContactsCountValidation = 7,
  PublicParentValidation = 8
}
